import React, { useState, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Star, MapPin } from "lucide-react";

const AboutLocalityProperty = () => {
  const [showFullDescription, setShowFullDescription] = useState(false);

  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
      offset: 100,
      easing: "ease-in-out",
    });
  }, []);

  const shortDescription =
    "Kalinga Nagar is a planned industrial and modern town of coastal Odisha. The locality has surrounded by ample amount of greenery and is considered one of the mega planned localities under Bhubaneswar Development Authority (BDA).";

  const fullDescription =
    "Kalinga Nagar is a planned industrial and modern town of coastal Odisha. The locality has surrounded by ample amount of greenery and is considered one of the mega planned localities under Bhubaneswar Development Authority (BDA). Other nearby localities include Patia, Chandrasekharpur, and Nayapalli. The area is well-connected with excellent infrastructure and modern amenities.";

  const mapUrl =
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3743.093307139546!2d85.77562897500934!3d20.254964681207714!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a19a782befbdd7b%3A0xb5c213af61368446!2sWeb_Bocket%20Classes%20%2C%20Khandagiri!5e0!3m2!1sen!2sin!4v1760444188893!5m2!1sen!2sin";

  const handleViewOnMap = () => {
    window.open(
      "https://www.google.com/maps/place/Web_Bocket+Classes+,+Khandagiri/@20.254965,85.775629,17z/data=!3m1!4b1!4m6!3m5!1s0x3a19a782befbdd7b:0xb5c213af61368446!8m2!3d20.254965!4d85.775629!16s%2Fg%2F11y3g8x9kv",
      "_blank"
    );
  };

  return (
    <section className="pt-6 md:pt-8 lg:pt-10 overflow-hidden">
      <div className="bg-white py-4">
        <div className="px-4 sm:px-6 md:px-8 lg:px-10 mx-auto w-full">
          <div
            className="flex flex-col lg:flex-row gap-6 sm:gap-8 md:gap-10 lg:gap-12"
            data-aos="fade-up"
          >
            {/* Left Panel */}
            <div
              className="w-full lg:w-1/2 flex flex-col justify-between"
              data-aos="fade-right"
            >
              <h2
                className="text-lg sm:text-2xl md:text-3xl font-semibold mb-3 sm:mb-4 text-gray-900 text-center lg:text-left"
                data-aos="zoom-in"
              >
                Kalinga Nagar, Bhubaneswar
              </h2>

              {/* About Section */}
              <div
                className="mb-6 sm:mb-8 md:mb-10"
                data-aos="fade-up"
                data-aos-delay="100"
              >
                <h3 className="text-base sm:text-xl md:text-2xl font-semibold text-gray-900 mb-2 sm:mb-3 text-center lg:text-left">
                  About Kalinga Nagar
                </h3>
                <p className="text-sm sm:text-base md:text-lg text-gray-600 leading-relaxed text-justify">
                  {showFullDescription ? fullDescription : shortDescription}{" "}
                  <button
                    onClick={() => setShowFullDescription(!showFullDescription)}
                    className="text-red-500 font-medium hover:text-red-600 inline-block ml-1"
                  >
                    {showFullDescription ? "Show Less" : "Read More"}
                  </button>
                </p>
              </div>

              {/* Rating Section */}
              <div
                className="flex flex-col sm:flex-row gap-4 sm:gap-6 items-start sm:items-center"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                <div className="border border-gray-200 rounded-lg p-3 sm:p-4 md:p-6 shadow-sm w-full sm:w-auto">
                  <div className="text-2xl sm:text-3xl md:text-4xl font-semibold mb-1 sm:mb-2 text-gray-900">
                    3.9
                  </div>
                  <div className="flex gap-1 mb-1 sm:mb-2">
                    {[1, 2, 3, 4].map((star) => (
                      <Star
                        key={star}
                        className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6 fill-yellow-400 text-yellow-400"
                      />
                    ))}
                    <Star className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6 text-gray-300" />
                  </div>
                  <div className="text-xs sm:text-sm md:text-base text-gray-500">
                    Reviews
                  </div>
                </div>

                <button
                  className="text-red-500 font-medium hover:text-red-600 text-sm sm:text-base self-start sm:self-auto mt-2 sm:mt-0"
                  data-aos="fade"
                  data-aos-delay="300"
                >
                  Write a Review
                </button>
              </div>
            </div>

            {/* Right Panel - Map */}
            <div
              className="w-full lg:w-1/2 relative h-56 sm:h-64 md:h-80 lg:h-96 rounded-lg overflow-hidden"
              data-aos="fade-left"
            >
              <iframe
                src={mapUrl}
                className="w-full h-full rounded-lg border-0"
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Kalinga Nagar Location Map"
              />
              <button
                onClick={handleViewOnMap}
                className="absolute bottom-3 sm:bottom-4 right-3 sm:right-4 bg-gray-900 text-white px-3 py-2 sm:px-4 sm:py-2 md:px-6 md:py-3 rounded-lg flex items-center gap-1 sm:gap-2 shadow-lg hover:bg-gray-800 transition-colors text-xs sm:text-sm md:text-base"
                data-aos="zoom-in"
                data-aos-delay="200"
              >
                <MapPin className="w-3 h-3 sm:w-4 sm:h-4 md:w-5 md:h-5" />
                View on Map
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutLocalityProperty;
